import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "button", "content", "icon"]
    static classes = ["expanded"]

    connect() {
        // 初始化时隐藏所有内容
        this.contentTargets.forEach(content => {
            content.style.display = 'none'
        })
    }

    toggle(event) {
        const button = event.currentTarget
        const item = button.closest('[data-faq-target="item"]')
        const content = item.querySelector('[data-faq-target="content"]')
        const icon = button.querySelector('[data-faq-target="icon"]')

        const isExpanded = button.getAttribute('aria-expanded') === 'true'

        // Toggle aria-expanded
        button.setAttribute('aria-expanded', !isExpanded)

        // Toggle icon rotation
        if (isExpanded) {
            icon.classList.remove('rotate-180')
            icon.classList.add('rotate-0')
        } else {
            icon.classList.remove('rotate-0')
            icon.classList.add('rotate-180')
        }

        // Toggle content visibility
        if (isExpanded) {
            content.style.display = 'none'
        } else {
            content.style.display = 'block'
        }
    }
} 